import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { List, TextField, Typography } from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import clsx from "clsx";
import { getCookie } from "../../services/Cookies";

const useStyles = makeStyles((theme) => ({
  // tablepadding : {
  //   padding:"10em",

  // },

  heading: {
    color: "#ff4717",
  },
  mb: {
    marginTop: "15px",
  },
  root: {
    display: "flex",
    padding: "0px",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: "65px",
    height: "100vh",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "white",
  },
  theadingstyles: {
    background: "#1A1A31",
    padding: "12px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    color: "white",
    fontSize: "16px",

  },

  activeListColor: {
    color: "#ff4717 !important",
  },
  shiplist: {
    "&.Mui-selected .MuiListItemText-root span": {
      color: "#ff4717 !important",
    }
  }
}));

const listStyled = withStyles({
  root: {
    " .Mui-selected": {
      background: "none !important",
    },
    // ".MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
    //   backgroundColor: "none !important",
    // },
  },
})(List);

export default function ShipList(props) {
  const classes = useStyles();
  const [selectedVesselKey, setSelectedVesselKey] = useState("");
  const { shipList, seletedShipItemList } = props;

  useEffect(() => {
  }, [])
  return (
    <div>
      <Grid container fluid="md" spacing={3}>
      
        <Grid item xs={12}>
          <Typography
            variant="h5"
            align="left"
            className={clsx(classes.heading, classes.theadingstyles) + " bai-font"}
          >
            Ship List 
          </Typography>
          <Paper
            className={classes.paper + " scrollBar"}
            style={{ height: "420px", overflow: "auto" }}
          >
              
            <listStyled component="nav" className="scroll-list">
              {shipList.length ? shipList.map((row, index) => (
                <ListItem className={clsx(classes.shiplist, "shiplist")}
                  button
                  onClick={(e) => {
                    //
                    setSelectedVesselKey(row.vesselKey);
                    seletedShipItemList(row);

                  }}
                  selected={row.vesselKey === selectedVesselKey ? true : (selectedVesselKey === "" && index == 0 ? true : false)}
                >
                  <ListItemText>
                    {row.currentVesselName}
                    <br />
                    {row.imono}
                  </ListItemText>
                </ListItem>
              )) : (
                <ListItem>
                  <ListItemText>No Data Found</ListItemText>
                </ListItem>
              )}
            </listStyled>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
